module.exports = __webpack_public_path__ + "static/media/banner-bg-grid.a37f1bdc.png";